import Card from '../../components/card/card.vue';

export default {
  name: 'Projects',
  data() {
    return {
      projects: [
        {
          title: 'Muze Programming Language',
          link: 'https://github.com/ACov96/muze-archive',
          content: 'Graduate research project. High-level programming language designed to optimally store object metadata in CPU registers on common x86-64 CPUs. Contributed primarily to the compiler backend/code generation and runtime library.'
        },
        {
          title: 'Dialect',
          link: 'https://github.com/ACov96/dialect',
          content: 'A proof of concept programming language featuring homoiconicity and Lisp-inspired macros for language extension at runtime. Developed in Python and available for install through the <a href="https://pypi.org/project/dialect/">PyPI repository</a>.'
        },
        {
          title: 'Go Lisp',
          link: 'https://github.com/ACov96/go-lisp',
          content: 'A small Lisp-dialect I developed using Go. Based on <a href="https://github.com/maryrosecook/littlelisp" target="_blank">Mary Rose Cook\'s Little Lisp in JavaScript</a>.'
        },
        {
          title: 'Image Super Scaler',
          link: 'https://github.com/ACov96/upscaler',
          content: 'A PyTorch-based convolutional neural network that aims to upscale images to resolutions higher than the original image without reducing quality.',
        },
        {
          title: 'Network Events',
          link: 'https://github.com/ACov96/network-events',
          content: 'My submission for Restek\'s 100-lines of code challenge. We wanted a lightweight events system for our microservices. Features events via sockets and HTTP and encrypted events/event payloads.'
        },
        {
          title: 'Smart Bike',
          link: 'https://youtu.be/_USowfs9e7U',
          content: 'Final project for WWU\'s Embedded Systems class. Bike changes gear based on cadence; the faster you go, the higher gear it will shift into. Built using an LPC1114F, programmed in C using a custom RTOS and drivers developed in class.'
        },
        {
          title: 'WWU Great Puzzle Hunt',
          link: 'https://www.greatpuzzlehunt.com',
          content: 'Joined the Great Puzzle Hunt development team and developed an automated testing suite using Mocha.'
        }
      ]
    };
  },
  components: {
    Card,
  },
};
